// extracted by mini-css-extract-plugin
export default {"closeBtn":"SelectedPanel_closeBtn__rvtuE","closeIcon":"SelectedPanel_closeIcon__hhxwE","item":"SelectedPanel_item__tCV7B"};